import { DOWNLOAD_APP_PATH } from "@/features/download-app/constants/storeLinks.constant";
import type { RouteConfig } from "@/router/types";
import { lazyWithRetry } from "@/shared/utils/lazyWithRetry";

const DownloadAppPage = lazyWithRetry(() => import("@/features/download-app/pages/DownloadAppPage"));

const downloadAppRoutes: RouteConfig[] = [
  {
    path: DOWNLOAD_APP_PATH,
    element: <DownloadAppPage />,
    isProtected: false,
    useMainLayout: false,
  },
];

export default downloadAppRoutes;
